export const TEXTS = {
  SHOW_OFERTA: 'Посмотреть оферту',
  OFERTA: 'Оферта',
};
